import { createSlice } from "@reduxjs/toolkit";

// Defino valor inicial para el estado de mi slice
const initialState = {
  data: [],
};

// creo el slice con toda su configuración y sus acciones
const personasSlice = createSlice({
  name: "personasSlice",
  initialState,
  reducers: {
    setPersonasList: (state, action) => {
      state.data = action.payload;
    },
  },
});

// Expongo las funcionalidades
export const { setPersonasList } = personasSlice.actions;

export default personasSlice.reducer;
